export function extractUsername(user) {
    return user.name || [user.first_name, user.last_name].filter((i) => i).join(' ');
}
